import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useMemo, useCallback } from 'react';
import { styled } from '@mui/material';
import MuiFormGroup from '@mui/material/FormGroup';
import Checkbox from './Checkbox.js';

const _MuiFormGroup = styled(MuiFormGroup) `
  min-width: 150px;
`;
const CheckboxList = (_a) => {
    var { options, disabled, onSelectionChange, searchValue } = _a, rest = __rest(_a, ["options", "disabled", "onSelectionChange", "searchValue"]);
    const checkedOptions = useMemo(() => options.filter(({ checked }) => checked), [options]);
    const onCheckboxToggle = useCallback((event) => {
        const { checked, name } = event.target;
        if (name === 'all') {
            onSelectionChange(options.map(item => {
                if (item.disabled) {
                    return item;
                }
                return Object.assign(Object.assign({}, item), { checked });
            }));
        }
        else {
            const updatedOptions = options.map(item => (item.name === name ? Object.assign(Object.assign({}, item), { checked }) : item));
            onSelectionChange(updatedOptions);
        }
    }, [options, onSelectionChange]);
    const selectAllLabel = `(Select All)`;
    const allChecked = checkedOptions.length === options.length;
    const filteredOptions = useMemo(() => searchValue
        ? options.filter(option => String(option.name).toLowerCase().includes(String(searchValue).toLowerCase()))
        : options, [options, searchValue]);
    return (jsxs(_MuiFormGroup, Object.assign({}, rest, { children: [jsx(Checkbox, Object.assign({ selectAll: true, "data-testid": "select-all", hint: "all", semi: checkedOptions.length > 0, checked: allChecked, onChange: onCheckboxToggle, disabled: disabled, name: "all" }, { children: selectAllLabel })), filteredOptions.map((_a) => {
                var { label, name, checked } = _a, rest = __rest(_a, ["label", "name", "checked"]);
                return (jsx(Checkbox, Object.assign({ name: name, checked: checked, "data-testid": `${name}-item`, onChange: onCheckboxToggle, disabled: rest.disabled || disabled }, { children: label }), `_${name}`));
            })] })));
};

export { CheckboxList as default };
//# sourceMappingURL=CheckboxList.js.map
